import CreateItemResponse from 'owa-service/lib/contract/CreateItemResponse';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import Message from 'owa-service/lib/contract/Message';
import itemId from 'owa-service/lib/factory/itemId';

export default function updateMessageId(automatedMessage: Message, response: CreateItemResponse) {
    const { ResponseMessages: { Items: [responseMessage] = [undefined] } = {} } = response;
    if (!responseMessage) {
        return;
    }
    let message = (responseMessage as ItemInfoResponseMessage).Items[0] as Message;

    if (message && message.ItemId) {
        automatedMessage.ItemId = itemId({ Id: message.ItemId.Id });
    }
}
